import A from './types';
// account level {public:0, free:1, standard:2, premium:3, professional:4}
const initialState = {
  orderInfo:null,
  orderStatus:'NOT_FINISH_YET',
  orderLoading:false
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.SELECTED_PAYMENT_PLAN: {
      if (action.payload) {
        return {
          selectedBill:action.payload
        }
      }
    }
    case A.SAVE_ORDER_INFO: {
      return {
        ...state,
        orderInfo:action.payload
      }
    }
    case A.SAVE_PAY_INFO: {
      return {
        ...state,
        payInfo:action.payload
      }
    }
    case A.SET_ORDER_LOADING_STATUS: {
      return {
        orderLoading:action.payload
      }
      
    }
    case A.SAVE_ORDER_STATUS: {
      return {
        ...state,
        orderStatus:action.payload
      }
    }

  }
  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/payment/reducer.js